import React, { useState } from "react";

import indoor from "../assets/images/Elysium_Tower/Amenities/Indoor.jpg"
import indoor2 from "../assets/images/Elysium_Tower/Amenities/Indoor2.jpg"
import Rooftop_Amenitiey_1 from "../assets/images/Elysium_Tower/Amenities/Rooftop_Amenitiey_1.jpg"
import Rooftop_Amenitiey_2 from "../assets/images/Elysium_Tower/Amenities/Rooftop_Amenitiey_2.jpg"
import Rooftop_Amenitiey_3 from "../assets/images/Elysium_Tower/Amenities/Rooftop_Amenitiey_3.jpg"
import Rooftop_Amenitiey_4 from "../assets/images/Elysium_Tower/Amenities/Rooftop_Amenitiey_4.jpg"
import Rooftop_Amenitiey_5 from "../assets/images/Elysium_Tower/Amenities/Rooftop_Amenitiey_5.jpg"
import Rooftop_Amenitiey_6 from "../assets/images/Elysium_Tower/Amenities/Rooftop_Amenitiey_6.jpg"

import "../assets/css/amenities.css"; // Add custom styles

const AmenitiesElysiumTower = () => {
    const [selectedFloor, setSelectedFloor] = useState("indoor");
    const [floorImg, setFloorImg] = useState(indoor);


    const changeFloor = (floor) => {
        setSelectedFloor(floor);
        if (floor === "indoor") {
            setFloorImg(indoor);
        } else if (floor === "indoor2") {
            setFloorImg(indoor2);
        } else if (floor === "Rooftop_Amenitiey_1") {
            setFloorImg(Rooftop_Amenitiey_1);
        } else if (floor === "Rooftop_Amenitiey_2") {
            setFloorImg(Rooftop_Amenitiey_2);
        } else if (floor === "Rooftop_Amenitiey_3") {
            setFloorImg(Rooftop_Amenitiey_3);
        } else if (floor === "Rooftop_Amenitiey_4") {
            setFloorImg(Rooftop_Amenitiey_4);
        } else if (floor === "Rooftop_Amenitiey_5") {
            setFloorImg(Rooftop_Amenitiey_5);
        } else if (floor === "Rooftop_Amenitiey_6") {
            setFloorImg(Rooftop_Amenitiey_6);
        }
    }

    return (
        <div className="amenities-container elysium_tower">
            <div className="scrollable-wrapper">
                <div className={`image-wrapper`}>
                    <img src={floorImg} alt="Amenities" className="responsive-image" />
                </div>
            </div>
            <div className="floor_buttons amenities_buttons">
                <ul>
                    <li>
                        <button
                            onClick={() => changeFloor("indoor")}
                            className={selectedFloor === "indoor" ? "active" : ""}
                        >
                            Indoor Amenities 1 & 2
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => changeFloor("indoor2")}
                            className={selectedFloor === "indoor2" ? "active" : ""}
                        >
                            Indoor Amenities 3, 4 & 5
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => changeFloor("Rooftop_Amenitiey_1")}
                            className={selectedFloor === "Rooftop_Amenitiey_1" ? "active" : ""}
                        >
                            Rooftop Amenity 1
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => changeFloor("Rooftop_Amenitiey_2")}
                            className={selectedFloor === "Rooftop_Amenitiey_2" ? "active" : ""}
                        >
                            Rooftop Amenity 2
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => changeFloor("Rooftop_Amenitiey_3")}
                            className={selectedFloor === "Rooftop_Amenitiey_3" ? "active" : ""}
                        >
                            Rooftop Amenity 3
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => changeFloor("Rooftop_Amenitiey_4")}
                            className={selectedFloor === "Rooftop_Amenitiey_4" ? "active" : ""}
                        >
                            Rooftop Amenity 4
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => changeFloor("Rooftop_Amenitiey_5")}
                            className={selectedFloor === "Rooftop_Amenitiey_5" ? "active" : ""}
                        >
                            Rooftop Amenity 5
                        </button>
                    </li>
                    <li>
                        <button
                            onClick={() => changeFloor("Rooftop_Amenitiey_6")}
                            className={selectedFloor === "Rooftop_Amenitiey_6" ? "active" : ""}
                        >
                            Rooftop Amenity 6
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default AmenitiesElysiumTower;
